import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import ReactPlayer from "react-player";
import VoteComponent from "./VoteComponent";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70dvw",
  height: { lg: "70dvh", md: "70dvh", sm: "49dvh", xs: "49dvh" },
  bgcolor: "#242743",
  border: "1px solid #414466",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",

  //   p: 4,
};

const headStype = {
  padding: "15px 15px",
  borderBottom: "1px solid #414466",
};

const contentStyle = {
  padding: "15px 15px",
  flexGrow: "1",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
};

export default function GoalModal({ open, setOpen, data, setTournamentData }) {
  const [voteState, setVoteState] = useState(data.voteCount);

  return (
    <Modal
      open={open}
      onClose={() => {
        setTournamentData((tourData) => {
          const newGoals = tourData.professionalTournamentGoals.map(
            (goalData) =>
              goalData.id == data.id
                ? {
                    ...goalData,
                    voteCount: voteState,
                    isVoted: goalData.voteCount == voteState ? 0 : 1,
                  }
                : goalData
          );
          const rankedGoals = newGoals.sort((a, b) =>
            a.voteCount > b.voteCount ? -1 : 1
          );
          return { ...tourData, professionalTournamentGoals: rankedGoals };
        });

        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box sx={headStype}>
          <IconButton
            onClick={() => {
              setTournamentData((tourData) => {
                const newGoals = tourData.professionalTournamentGoals.map(
                  (goalData) =>
                    goalData.id == data.id
                      ? {
                          ...goalData,
                          voteCount: voteState,
                          isVoted: goalData.voteCount == voteState ? 0 : 1,
                        }
                      : goalData
                );
                const rankedGoals = newGoals.sort((a, b) =>
                  a.voteCount > b.voteCount ? -1 : 1
                );
                return {
                  ...tourData,
                  professionalTournamentGoals: rankedGoals,
                };
              });
              setOpen(false);
            }}
          >
            <ArrowBackIcon sx={{ color: "white" }} />
          </IconButton>
        </Box>

        <Box sx={{ borderBottom: "1px solid #414466" }}></Box>
        <Box sx={contentStyle}>
          <Box
            sx={{
              width: "100%",
              height: "70%",
              flexGrow: "1",
              //   maxWidth: "500px",
              //   maxHeight: "250px",
            }}
          >
            <ReactPlayer
              url={data.video}
              controls={true}
              width="100%"
              height="100%"
              config={{
                file: {
                  attributes: {
                    poster: data.thumbnail,
                  },
                },
              }}
            />
          </Box>

          <Box sx={{ marginTop: "20px" }}>
            <VoteComponent
              id={data.id}
              vote={data.isVoted}
              count={voteState}
              setCount={setVoteState}
              // setTournamentData={setTournamentData}
            />
            <Typography
              component="p"
              sx={{
                color: "white",
                fontSize: { sm: "18px", xs: "16px", md: "20px" },
              }}
            >
              <strong>club:</strong>
              {data?.club_name}
            </Typography>
            <Typography
              component="p"
              sx={{
                color: "white",
                fontSize: { sm: "18px", xs: "16px", md: "20px" },
              }}
            >
              <strong>goal scorer:</strong>
              {data?.goal_scorer}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
